import { FormEvent } from 'react'

export function isReviewSubmission(event: FormEvent) {
  const submitter = (event.nativeEvent as SubmitEvent).submitter
  return submitter instanceof HTMLButtonElement && submitter.name === 'intent' && submitter.value === 'review'
}
